import request from '@/utils/request'

export function getStudentHomeOverview() {
    return request({
        url: '/api/student/home/overview',
        method: 'get'
    })
}

export function getStudentHomePracticeList() {
    return request({
        url: '/api/student/home/practice',
        method: 'get'
    })
}

export function getStudentHomeExamList() {
    return request({
        url: '/api/student/home/exam',
        method: 'get'
    })
}